import { AxiosResponse } from "axios";
import { useContext, useEffect, useState } from "react";
import { Container, Dropdown, Nav, Navbar } from "react-bootstrap";
import { BiUserCircle } from "react-icons/bi";
import { FaRegLightbulb } from "react-icons/fa";
import { HiOutlineMenuAlt1 } from "react-icons/hi";
import { useProSidebar } from "react-pro-sidebar";
import { useNavigate } from "react-router";
import { logout } from "../../common/utils/api";
import {
  authorizationConstant,
  AuthType,
  CommonConstants,
  steps,
} from "../../common/utils/CommonConstants";
import { CommonGatewayAxiosPost } from "../../common/utils/helper";
import { useTour } from "../../common/utils/TourContext";
import { UserContext } from "../layout/layout";
import NotificationsModal from "../notification/notificationModal";
import ChangePasswordModel from "./ChangePasswordModel";
import "./header.scss";

function Header() {
  const { collapseSidebar, broken, toggleSidebar } = useProSidebar();
  const { user, setUser }: any = useContext(UserContext);
  const navigate = useNavigate();
  const [showNotification, setShowNotification] = useState(false);
  const [openChangePasswordModel, setChangePasswordModel] =
    useState<boolean>(false);
  const { setSteps, startTour, getDriverInstance, isTourEnabled } = useTour();
  const [shouldStart, setShouldStart] = useState(false);

  const logOut = async () => {
    if (location.pathname != "/login") {
      let response;
      response = (await CommonGatewayAxiosPost(logout, {})) as AxiosResponse;
      if (response.status === CommonConstants.API_RESPONSE_SUCCESSFULL) {
        setUser({});
        localStorage.clear();
        setTimeout(() => {
          navigate("/login");
        }, 100);
      }
    }
  };

  const generateSteps = () => {
    const cleanedAccess = user?.access?.map(
      (item: string) => item.replace(/\s+/g, "") // remove all spaces
    );

    // Pages that require special grouped permission check
    const accessMap: Record<string, string[]> = {
      resourceManagement: authorizationConstant?.resourcePageList || [],
      candidateManagement: authorizationConstant?.candidatePageList || [],
      roleManagement: authorizationConstant?.rolePageList || [],
      masterData: authorizationConstant?.masterPageList || [],
      accessManagement: authorizationConstant?.accessPageList || [],
      systemConfiguration:
        authorizationConstant?.systemConfigurationPageList || [],
    };

    const filteredSteps = steps?.filter((step) => {
      const id = step?.element?.replace("#", "");
      if (id === "Welcome") return true;
      if (
          (id === "ResumeDashboard" || id === "SmartResumeParser") &&
          user?.access?.includes("Resume Screening")
        ) {
          return true;
        }
      if (cleanedAccess?.includes(id)) return true;

      const requiredPages = accessMap[id];
      if (
        requiredPages?.some((access: string) => user?.access?.includes(access))
      ) {
        return true;
      }
      return false;
    });
    return filteredSteps;
  };

  useEffect(() => {
    if (localStorage.getItem("isAppTourCompleted") == "true") {
      setShouldStart(false);
    } else {
      setShouldStart(true);
    }
  }, []);

  useEffect(() => {
    const filteredSteps = generateSteps(); // your logic here
    setSteps(filteredSteps);
  }, []);

  useEffect(() => {
    if (shouldStart) {
      startTour();
      setShouldStart(false); // reset flag
    }
  }, [shouldStart, startTour]);

  return (
    <div className="navsec">
      <Navbar className="navbar px-2 navbar-expand-lg">
        <Container fluid>
          {broken && (
            <button className="togglemenu" onClick={() => toggleSidebar()}>
              <HiOutlineMenuAlt1 />
            </button>
          )}
          {!broken && (
            <button className="togglemenu" onClick={() => collapseSidebar()}>
              <HiOutlineMenuAlt1 />
            </button>
          )}
          <Navbar.Collapse id="navbarScroll">
            <div className="orgName">{user?.OrganizationName}</div>
            <Nav className="ms-auto">
              {isTourEnabled &&<div className="user-guide">
                <FaRegLightbulb
                  width={"25px"}
                  height={"25px"}
                  title="App Guide"
                  onClick={() => startTour()}
                  className="user-guide"
                />
              </div>}
              <Dropdown>
                <Dropdown.Toggle className="userdropdown" id="user-dropdown">
                  <BiUserCircle className="me-2" size={28} />
                  {user.FirstName} {user.LastName}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {user?.authType === AuthType.DEFAULT && (
                    <Dropdown.Item
                      href="#"
                      onClick={() => setChangePasswordModel(true)}
                    >
                      Change Password
                    </Dropdown.Item>
                  )}
                  {(user?.RoleId === authorizationConstant?.roleSuperAdminId ||
                    user?.IsSystemAdmin) && (
                    <Dropdown.Item
                      onClick={() => {
                        navigate(`/subscriptions`);
                      }}
                    >
                      Subscriptions
                    </Dropdown.Item>
                  )}
                  {/* {user?.RoleId === authorizationConstant?.roleSuperAdminId && (
                    <Dropdown.Item
                      onClick={() => {
                        navigate(`/changePlan`);
                      }}
                    >
                      Change Plan
                    </Dropdown.Item>
                  )} */}
                  <Dropdown.Item
                    href="/login"
                    onClick={(e) => {
                      e?.preventDefault();
                      logOut();
                    }}
                  >
                    Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <NotificationsModal
        open={showNotification}
        setOpen={setShowNotification}
      />
      <ChangePasswordModel
        setOpen={setChangePasswordModel}
        open={openChangePasswordModel}
      />
    </div>
  );
}

export default Header;
